// eslint-disable-next-line @typescript-eslint/no-namespace
export var NamespaceStore;
(function (NamespaceStore) {
  var ScreensEnum;
  (function (ScreensEnum) {
    ScreensEnum[ScreensEnum["GAME_START"] = 0] = "GAME_START";
    ScreensEnum[ScreensEnum["GAME_SCREEN"] = 1] = "GAME_SCREEN";
    ScreensEnum[ScreensEnum["GAME_END"] = 2] = "GAME_END";
  })(ScreensEnum = NamespaceStore.ScreensEnum || (NamespaceStore.ScreensEnum = {}));
  var Directions;
  (function (Directions) {
    Directions[Directions["ACROSS"] = 0] = "ACROSS";
    Directions[Directions["DOWN"] = 1] = "DOWN";
  })(Directions = NamespaceStore.Directions || (NamespaceStore.Directions = {}));
  var LayoutType;
  (function (LayoutType) {
    LayoutType["desktop"] = "desktop";
    LayoutType["mobile"] = "mobile";
    LayoutType["tablet"] = "tablet";
  })(LayoutType = NamespaceStore.LayoutType || (NamespaceStore.LayoutType = {}));
  var Orientation;
  (function (Orientation) {
    Orientation["portrait"] = "portrait";
    Orientation["landscape"] = "landscape";
  })(Orientation = NamespaceStore.Orientation || (NamespaceStore.Orientation = {}));
  var CluesPosition;
  (function (CluesPosition) {
    CluesPosition[CluesPosition["LEFT"] = 0] = "LEFT";
    CluesPosition[CluesPosition["RIGHT"] = 1] = "RIGHT";
  })(CluesPosition = NamespaceStore.CluesPosition || (NamespaceStore.CluesPosition = {}));
  var MaxificationPopups;
  (function (MaxificationPopups) {
    MaxificationPopups["signUp"] = "signUp";
    MaxificationPopups["profile"] = "profile";
    MaxificationPopups["createProfile"] = "createProfile";
    MaxificationPopups["signInWelcome"] = "signInWelcome";
    MaxificationPopups["subscriptionCongrats"] = "subscriptionCongrats";
    MaxificationPopups["subscriptionThanks"] = "subscriptionThanks";
    MaxificationPopups["subscriptionAdvantagesWithIcons"] = "subscriptionAdvantagesWithIcons";
    MaxificationPopups["subscriptionAdvantagesWithText"] = "subscriptionAdvantagesWithText";
    MaxificationPopups["conditions"] = "conditions";
    MaxificationPopups["confirmDeleteAccount"] = "confirmDeleteAccount";
  })(MaxificationPopups = NamespaceStore.MaxificationPopups || (NamespaceStore.MaxificationPopups = {}));
  var Popups;
  (function (Popups) {
    Popups["void"] = "void";
    Popups["debug"] = "debug";
    Popups["puzzleInfo"] = "puzzleInfo";
    Popups["resetPuzzle"] = "resetPuzzle";
    Popups["exitPuzzle"] = "exitPuzzle";
    Popups["printPuzzle"] = "printPuzzle";
    Popups["credits"] = "credits";
    Popups["tutorial"] = "tutorial";
    Popups["reveal"] = "reveal";
    Popups["check"] = "check";
    Popups["noInternet"] = "noInternet";
    Popups["creatorNotes"] = "creatorNotes";
  })(Popups = NamespaceStore.Popups || (NamespaceStore.Popups = {}));
})(NamespaceStore || (NamespaceStore = {}));